const IndexPagination = (rowPerpage, activeIndex, index) => {
  return rowPerpage * (activeIndex - 1) + index;
};
export default IndexPagination;
